// extracted by mini-css-extract-plugin
export default {"box":"House_box__63zmK","btn":"House_btn__TTBl5"};